import React from "react";
import styles from "./HomeBanner.module.scss";
import QRCodeMan from "./assets/qrCodeWithMan.png";
import PlayBtn from "./assets/playbtn.png";
import AppleBtn from "./assets/applebtn.png";
import { motion } from "framer-motion";
const { banner, texts, imgs } = styles;
const HomeBanner = () => {
  return (
    <section className={`${banner} global-lr-pad`}>
      <motion.div
        className={texts}
        initial={{
          x: "-50vw",
          opacity: 0,
        }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { 
            duration : .5 , 
            type : 'tween'
          }
        }}
      >
        <h1>
          <span>Shop</span> - Pay- <span>Save</span>
        </h1>
        <p>
          fast & SECURE PAYMENT ONE QUICK SCAN. Payment Invoice & Receipt
          Generation Made Easy experience seamless and interesting.{" "}
        </p>
        <div>
          <img src={PlayBtn} alt="download from playstore" />
          <img src={AppleBtn} alt="download from applestore" />
        </div>
      </motion.div>

      <motion.div 
      initial={{
          x: "50vw",
          opacity: 0,
        }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { 
            duration : .5 , 
            type : 'tween' , 
            delay: .3
          }
        }} className={imgs}>
        <img src={QRCodeMan} alt="QT Scanner" />
      </motion.div>
    </section>
  );
};

export default HomeBanner;
